import type MP4Box from 'mp4box';
import { TrackEventProp } from '@studio/constants/tracking-constants';
import type { AddError, VideoUploadTrackEventProperties } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';
import { hasAudio } from '../hasAudio';

const validateMaxAudioChannels = (
  info: MP4Box.Mp4BoxInfo,
  addError: AddError,
  trackEventProperties: VideoUploadTrackEventProperties
): void => {
  if (!hasAudio(info)) {
    return;
  }
  const [audioTrack] = info.audioTracks;
  console.log(`Audio channels: ${audioTrack.audio.channel_count}`);

  trackEventProperties[TrackEventProp.VIDEO_UPLOAD_AUDIO_CHANNELS] = audioTrack.audio.channel_count;

  if (audioTrack.audio.channel_count > 16) {
    addError(VALIDATIONS.MAX_AUDIO_CHANNELS);
  }
};

export default validateMaxAudioChannels;
